import { ContentActionTypes, RequestContentSliceAction } from './ActionTypes';
import { ContentType } from '../models/ContentType';

// From start (inclusive) to end (exclusive)
export function requestContentSlice(offset: number, count: number, contentType: ContentType): RequestContentSliceAction {
  return {
    type: ContentActionTypes.REQUEST,
    offset: offset,
    count: count,
    contentType: contentType,
  };
}
